import { createSlice } from "@reduxjs/toolkit";

// Admin-only client state: while set, the My Ranking page shows the
// impersonated player's record instead of the logged-in user's. Session
// only (cleared on refresh) - deliberately not persisted.
const impersonationSlice = createSlice({
  name: "impersonation",
  initialState: {
    player: null, // { bsa_number, firstName, lastName }
  },
  reducers: {
    startImpersonation: (state, action) => {
      state.player = action.payload;
    },
    stopImpersonation: (state) => {
      state.player = null;
    },
  },
});

export const { startImpersonation, stopImpersonation } =
  impersonationSlice.actions;

export default impersonationSlice.reducer;
